import country from '../../../structuredData/types/country';
import imageObject from '../../../structuredData/types/imageObject';
export default {
  name: 'MoreGrowth',
  url: 'https://moregrowth.com',
  logo: imageObject({
    id: 'https://moregrowth.com#logo',
    caption: 'MoreGrowth',
    url: 'https://moregrowth.com/images/favicon-196x196.png'
  }),
  address: {
    streetAddress: 'Okopowa 58/72',
    addressLocality: 'Warszawa',
    addressRegion: 'mazowieckie',
    addressCountry: country({
      name: 'PL'
    }),
    postalCode: '01-042'
  },
  founder: [{
    givenName: 'Kuba',
    familyName: 'Koziej'
  }, {
    givenName: 'Piotrek',
    familyName: 'Sosnowski'
  }],
  knowsLanguage: ['https://www.wikidata.org/wiki/Q1860', 'https://www.wikidata.org/wiki/Q809'],
  knowsAbout: ['https://www.google.com/search?kgmid=/m/0h01f', 'https://www.google.com/search?kgmid=/m/01m2bt', 'https://www.google.com/search?kgmid=/m/0wpwgls', 'https://www.google.com/search?kgmid=/g/121jnq1m', 'https://www.google.com/search?kgmid=/g/122hcnps', 'marketing https://www.google.com/search?kgmid=/m/06mw8r', 'https://www.google.com/search?kgmid=/m/019qb_'],
  alternateName: ['More Growth'],
  vatID: 'PL5252906010',
  taxID: '5252906010',
  subjectOf: ['https://ain.capital/2022/07/28/polish-venture-builder-more-growth-raises-5m/', 'https://czasebiznesu.pl/polska-firma-venture-more-growth-ma-duze-ambicje-pozyskujac-5-milionow-dolarow-w-rundzie-pre-seed/', 'https://finalscout.com/company/more_growth', 'https://finmag.co.uk/company-showcase-more-growth-helping-millions-make-crucial-life-choices/', 'https://fintek.pl/startup-more-growth-pozyskal-23-mln-pln-w-najwiekszej-rundzie-pre-seed-w-polsce/', 'https://inwestycje.pl/biznes/more-growth-pozyskal-23-mln-zl-na-budowe-marek-i-produktow-online/', 'https://mamstartup.pl/more-growth-zgarnia-23-mln-zl-to-najwieksza-runda-pre-seed-w-polsce/', 'https://spidersweb.pl/bizblog/more-growth/', 'https://tech.eu/2022/07/27/polands-more-growth-has-big-ambitions-raises-5-million-in-pre-seed-round/', 'https://www.cbinsights.com/company/more-growth', 'https://www.forbes.pl/biznes/more-growth-specjalisci-od-rozwiazywania-problemow/sencsp4', 'https://www.isbtech.pl/2022/07/more-growth-pozyskuje-23-mln-zl-na-budowe-marek-i-produktow-online-pomagajacych-dbac-o-wellbeing/', 'https://www.pb.pl/tworcy-interviewme-odpalili-nowy-biznes-1156934', 'https://mycompanypolska.pl/artykul/megarunda-finansowania-polskiego-startupu-%22to-jedna-z-najwiekszych-rund-pre-seed-w-polsce%22/9783', 'https://startup.pfr.pl/pl/aktualnosci/dwa-tygodnie-z-vc-duze-wczesne-rundy/', 'https://sifted.eu/articles/polish-startups-to-watch', 'https://wyszukiwarka-krs.ms.gov.pl/dane-szczegolowe-podmiotu;numerKRS=cvtL7tHkklR%2FZc%2BunC75%2Bg%3D%3D;typ=P'],
  sameAs: ['https://www.linkedin.com/company/we-are-more-growth/', 'https://moregrowth.recruitee.com/', 'https://rocketjobs.pl/brands/story/more-growth-ventures', 'https://pracodawcy.pracuj.pl/company/1074100541', 'https://students.pl/pracodawcy/more-growth/', 'https://www.crunchbase.com/organization/more-growth', 'https://pitchbook.com/profiles/company/498486-97', 'https://wellfound.com/company/more-growth', 'https://www.wikidata.org/wiki/Q118955161', 'https://www.google.com/search?kgmid=/g/11s5nrdn9x', 'https://golden.com/wiki/More_Growth-K3DBPEE', 'https://linktr.ee/moregrowth'],
  legalName: 'More Growth sp. z o.o.',
  foundingDate: '2022',
  foundingLocation: {
    address: {
      addressLocality: 'Warszawa',
      addressCountry: country({
        name: 'PL'
      }),
      addressRegion: 'mazowieckie'
    }
  },
  contactPoint: {
    contactType: 'customer service',
    email: 'hello@moregrowth.com',
    url: 'https://moregrowth.com/contact'
  },
  slogan: 'Exponential growth. Real impact. Extreme ownership. Radical candor.',
  description: 'MoreGrowth is a technology startup company based in Warsaw, Poland. The company was founded in 2022 by Kuba Koziej and Piotr Sosnowski. MoreGrowth are the company behind brands such as Natu.Care, HelloFinance, and HiJunior.'
};